import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
  Output,
  EventEmitter
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material";
import { TestSchedulerService } from "../services/test_scheduler.service";
import { AuthenticationService } from "../services/authentication.service";
import { SwalService } from "../services/swal.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";


@Component({
  templateUrl: "./student-details.component.html",
  styleUrls: ["./student-details.component.scss"]
})
export class StudentDetailsComponent implements OnInit {
  displayedColumns: any[] = [];
  detailsFromDb: any[] = [];
  categoryFromDb: any[] = [];
  count: any[] = [];
  categoryCount: Object = {};
  userId: string[] = [];
  finalObject: Record<string, unknown> = {};
  finaledArray: any[] = [];
  studentdata: any[] = [];
  College_Id: string;
  Year_Id: string;
  isTerminated = false;
  logOutCount = 0;
  notLoggedInCount = 0;
  loggedInCount = 0;
  viewNotLogOutStudent = false;
  totalStudents: any;
  columns: string[]; //holds category
  notAnsweredCandidates: any[];
  infoModal:any

  displayTable: boolean;
  isLoading = false;

  dataLength: any;

  private tableReady = false;
  categorywithCount: Object = {};
  columnWithCategoryCount: any[] = [];

  dataSource: MatTableDataSource<any>;
  SelectedQuestionSet: any;
  studentDetails: any[] = [];
  user_arr: any = {
    user_name: "",
    password: ""
  };
  user_response: any;

  options = [
    { value: "All", viewValue: "All" },
    { value: "LoggedOut", viewValue: " LoggedOut Candidates" },
    { value: "LoggedIn", viewValue: " LoggedIn Candidates" },
    { value: "Not Logged In", viewValue: " Not LoggedIn Candidates" },
    { value: "test attended", viewValue: " Test attended Candidates" }
  ];
  selectedOption: any = "All";

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() loggedInStudentsEvent = new EventEmitter<number>();
  @ViewChild("content") modalContent: TemplateRef<any>;

  constructor(
    private testschedulerservice: TestSchedulerService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthenticationService,
    private swalservice: SwalService,
    private modal: NgbModal,
  ) {}

  ngOnInit() {
    console.log("this.route.snapshot.params", this.route.snapshot.params);
    this.SelectedQuestionSet = this.route.snapshot.params.Question_Set_Id;
    this.College_Id = this.route.snapshot.params.College_Id;
    this.Year_Id = this.route.snapshot.params.Year;
    this.totalStudents = this.route.snapshot.params.Total_Students;

    this.isLoading = true;

    this.getTableData();
  }

  ngAfterViewInit() {
    this.tableReady = true;
  }
openModal(){
  let ngbModalOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  //Open modal on clicking info icon
  this.infoModal = this.modal.open(this.modalContent, ngbModalOptions);
  this.infoModal.open(this.infoModal,ngbModalOptions)
}
closeModal(){
  this.infoModal.close(this.modalContent)
}
  async getColumnsData() {
    this.categorywithCount = [];
    this.detailsFromDb = [];
    this.columns = [];
    this.columnWithCategoryCount = [];
    this.categoryCount = {};

    this.testschedulerservice.fetchColumns(this.SelectedQuestionSet).subscribe(
      async data => {
        console.log(data, "in getting columns for  student table");
        this.detailsFromDb = await data.results;

        this.detailsFromDb.forEach(m => {
          if (m.Section_Name.toLowerCase().includes('essay')) m.Total_Count = 1;
          this.categoryCount[m.Section_Name] = m.Total_Count;
          this.categorywithCount[`${m.Section_Name} (${m.Total_Count})`] =
            m.Total_Count;
        });

        this.columns = Object.keys(this.categoryCount); //holds category
        this.columnWithCategoryCount = Object.keys(this.categorywithCount); // hold category with count

        console.log("columns to display", this.columns);

        console.log("category count", this.categoryCount);
      },
      err => {
        console.error(err);
      }
    );
    return this.columns;
  }

  async getTableData() {
    this.columns = await this.getColumnsData();

    this.finaledArray = [];
    this.isLoading = true;
    this.notLoggedInCount = 0;
    this.loggedInCount = 0;
    this.logOutCount = 0;
    
    this.testschedulerservice.fetchAnsweredStudents(this.College_Id).subscribe(
      data => {
        console.log(data, "data from server");
        //fetch and display not logged in students
        if (data.length == 0) {
          this.isLoading = true;
          this.userId = ["0"]; //to fetch all registered candidates
          this.fetchUnAnsweredStudents(this.userId,"1");
        }
        //to merge logged in and not logged in candidates
        else {
          if (this.tableReady == true) {
            this.studentdata = [];
            console.log("insdie tableReady true");
            this.displayTable = true;
            this.studentdata = data;
            this.finaledArray = [];
            this.userId = [];

            for (let j = 0; j < this.studentdata.length; j++) {
              this.userId.push(this.studentdata[j].user_id);
            }

            //grouping user ids
            this.userId = Array.from(new Set(this.userId));
            var pushAnsweredUsers=[]

            for (let i = 0; i < this.userId.length; i++) {
              console.log("loop", i);
              const finalObject: Record<string, unknown> = {}; // Initialize a new finalObject per user
            

              for (let data = 0; data < this.studentdata.length; data++) {
            
                if (this.studentdata[data].user_id === this.userId[i]) {
                  finalObject["Name"] = this.studentdata[data].First_Name;
                  finalObject["Username"] = this.studentdata[data].userName;
                  finalObject["Is Terminated"] = this.studentdata[
                    data
                  ].Is_terminated;
                  if (this.studentdata[data].Is_Logged === "Y") {

                    finalObject["Is LoggedOut"] = "No";
                    if(!pushAnsweredUsers.includes(this.studentdata[data].user_id)){
                     this.loggedInCount=this.loggedInCount+1
                    }
                    
                  }
                  if (this.studentdata[data].Is_Logged === "YES") {
                    finalObject["Is LoggedOut"] = "Yes";
                    if(!pushAnsweredUsers.includes(this.studentdata[data].user_id)){
                    this.logOutCount=this.logOutCount+1
                    }
                  }
                  //fetch details of logged in and  terminated user
                  if (this.studentdata[data].Is_Logged === null) {
                    finalObject["Is LoggedOut"] = "NA";
                    if(!pushAnsweredUsers.includes(this.studentdata[data].user_id)){
                    this.notLoggedInCount=this.notLoggedInCount+1
                     }
                  }

                  pushAnsweredUsers.push(this.studentdata[data].user_id)

                  console.log(this.studentdata[data], "student object");

                  for (let c = 0; c < this.columns.length; c++) {
                    if (
                      this.studentdata[data].Section_Name === this.columns[c]
                    ) {
                       if (
                        parseInt(this.studentdata[data].total_questions) <
                        parseInt(this.categoryCount[this.studentdata[data].Section_Name])
                      ) {
                        if (this.studentdata[data].Is_Logged === "YES") {
                          finalObject[
                            `${this.studentdata[data].Section_Name} (${
                              this.categoryCount[
                                this.studentdata[data].Section_Name
                              ]
                            })`
                          ] = `In Complete(${this.studentdata[data].total_questions})`;
                        } else {
                          console.log("inside less");
                          finalObject[
                            `${this.studentdata[data].Section_Name} (${
                              this.categoryCount[
                                this.studentdata[data].Section_Name
                              ]
                            })`
                          ] = `In Progress (${this.studentdata[data].total_questions})`;
                        }
                      }
                      if (
                        parseInt(this.studentdata[data].total_questions) === 
                        parseInt(this.categoryCount[this.studentdata[data].Section_Name])
                      ) {
                        console.log("inside comp");

                        finalObject[
                          `${this.studentdata[data].Section_Name} (${
                            this.categoryCount[
                              this.studentdata[data].Section_Name
                            ]
                          })`
                        ] = "Completed";
                      }
                    }
                  }
                }
              }

              for (let c = 0; c < this.columnWithCategoryCount.length; c++) {
                const category = this.columnWithCategoryCount[c];

                const columns = Object.keys(finalObject);

                const isCategoryPresent = columns.includes(category); //need to check this case

                if (!isCategoryPresent) {
                  finalObject[
                    `${this.columns[c]} (${
                      this.categoryCount[this.columns[c]]
                    })`
                  ] = "Not started";
                }
              }

              this.finaledArray.push(finalObject);
            }

            this.displayedColumns = Object.keys(this.finaledArray[0]);
            this.displayedColumns.push("Actions");

            //to fetch not logged in candidates
            this.fetchUnAnsweredStudents(this.userId,"0");

            // for (let j = 0; j < this.finaledArray.length; j++) {
            //   console.log(
            //     "in for loop of counting no of questions",
            //     this.finaledArray
            //   );
            //   if (this.finaledArray[j]["Is LoggedOut"] === "Yes") {
            //     this.logOutCount = this.logOutCount + 1;
            //   }
            //   //answered count
            //   if (this.finaledArray[j]["Is LoggedOut"] !== "NA") {
            //     this.loggedInCount = this.loggedInCount + 1;
            //   }
            // }
          }
        }
      },
      err => {
        console.error(err);
      }
    );
  }
  //refetch details(while reload)
  refetchData() {
 
    this.selectedOption="All"
    this.getTableData();
  }
  getStyle() {
    console.log("inside getstyle");
    if (this.displayTable == true) {
      return { "margin-top": "0px" };
    } else {
      return { "margin-top": "10px" };
    }
  }
  back() {
    this.router.navigate(["view_completed_college"]);
  }

  async giveReaccess(data) {
    this.user_arr = {
      user_name: data,
      password: ""
    };
    console.log("details to reaccess", this.user_arr);
    const result: any = await this.checkStatusOfUser(data);
    if (result === "Not Logged") {
      this.user_arr.user_name = "";
      this.user_arr.password = "";
      return this.swalservice.showAlert(
        "Candidate Not Logged In",
        "Sorry! This candidate is not logged in",
        "warning",
        false,
        "OK"
      );
    }

    this.auth.giveReAccess(this.user_arr).subscribe(data => {
      this.user_response = data.results;
      if (data.code == 200) {
        this.isTerminated = false;
        this.swalservice.showAlert(
          "Success",
          "User Allowed to retake exam :)",
          "success",
          false,
          "OK"
        );
        this.user_arr.user_name = "";
        this.user_arr.password = "";
      }
    });
  }

  async terminate(data) {
    this.user_arr = {
      user_name: data,
      password: ""
    };
    const result: any = await this.checkStatusOfUser(data);
    if (result === "Not Logged") {
      this.user_arr.user_name = "";
      this.user_arr.password = "";
      return this.swalservice.showAlert(
        "Candidate Not Logged In",
        "Sorry! This candidate is not logged in yet ",
        "warning",
        false,
        "OK"
      );
    }

    if (result === "Logged Out") {
      this.user_arr.user_name = "";
      this.user_arr.password = "";
      return this.swalservice.showAlert(
        "Candidate Logged Out",
        "Sorry! This candidate is already logged out",
        "warning",
        false,
        "OK"
      );
    }
    console.log("after checking login status*****");
    this.swalservice
      .showAlert(
        "Are you sure about terminating this user?",
        "",
        "warning",
        true,
        "OK"
      )
      .then(result => {
        if (result.isConfirmed) {
          console.log("detail to terminate", this.user_arr);
          this.auth.terminateuser(this.user_arr).subscribe(data => {
            this.user_response = data.results;
            if (data.code == 200) {
              this.isTerminated = true;
              this.swalservice.showAlert(
                "Success",
                "Candidate terminated successfully!",
                "success",
                true,
                "OK"
              );
              this.user_arr.user_name = "";
              this.user_arr.password = "";
            }
          });
        }
      });
  }

  onChange(event: any, i: any){
    const selectedValue = event.target.value; // Get the selected value
    this.selectedOption=selectedValue
  }
  searchtFilters() {
   this.isLoading=true
   
    var filterArray: any[] = [];
    const selectedValue=this.selectedOption;
    if (selectedValue !== "All") {
      if (selectedValue == "LoggedOut") {
        console.log("inside not logged out candidates view");
        filterArray = this.finaledArray.filter(item => {
          return item["Is LoggedOut"] === "Yes";
        });
      }
      if (selectedValue === "LoggedIn") {
        console.log("inside login ");
        filterArray = this.finaledArray.filter(item => {
          return (
             item["Is LoggedOut"] === "No" 
          );
        });
       
      }
      if (selectedValue === "test attended") {
        console.log("inside login ");
        filterArray = this.finaledArray.filter(item => {
          return (
            item["Is LoggedOut"] === "Yes" || item["Is LoggedOut"] === "No" 
          );
        });
      }
      if (selectedValue === "Not Logged In") {
        console.log("inside not logged in ");
        filterArray = this.finaledArray.filter(item => {
          return item["Is LoggedOut"] === "NA" ;
        });
      }
      if (filterArray.length==0){
        this.displayTable=false
      }else{
        this.displayTable=true
      }
      this.dataSource = new MatTableDataSource(filterArray);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      console.log("datsource", this.dataSource);
    } else {
      this.displayAllStudents();
    }
    this.isLoading=false
  }

  displayAllStudents() {
    this.viewNotLogOutStudent = false;

    if (this.finaledArray.length !== 0) {
      this.displayTable = true;
    } else {
      this.displayTable = false;
    }

    this.dataSource = new MatTableDataSource(this.finaledArray);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("datsource", this.dataSource);
  }

  fetchUnAnsweredStudents(data,unansweredflag) {
    console.log("inside fetching not logged in students****");

    const ids = { ids: data };
    this.testschedulerservice
      .fetchUnAnsweredStudents(this.College_Id, ids)
      .subscribe(
        data => {
          this.notAnsweredCandidates = data;

          // this.notLoggedInCount = data.length; 

          console.log(data, "data from server***");

          if (this.notAnsweredCandidates.length !== 0) {
            console.log("inside if");
            for (let i = 0; i < this.notAnsweredCandidates.length; i++) {
              console.log("inside for loop");
              const notLogInStudentObject: Object = {};
              notLogInStudentObject["Name"] = this.notAnsweredCandidates[
                i
              ].First_Name;
              notLogInStudentObject["Username"] = this.notAnsweredCandidates[
                i
              ].Username;
              if (this.notAnsweredCandidates[
                i
              ].Is_Logged === "Y") {
                notLogInStudentObject["Is LoggedOut"] = "No";

               
                this.loggedInCount=this.loggedInCount+1
            
              }
              if (this.notAnsweredCandidates[
                i
              ].Is_Logged === "YES") {
                notLogInStudentObject["Is LoggedOut"] = "Yes";
              }
              //fetch details of logged in and  terminated user
              if (this.notAnsweredCandidates[
                i
              ].Is_Logged === null) {
                notLogInStudentObject["Is LoggedOut"] = "NA";
              
                  this.notLoggedInCount=this.notLoggedInCount+1
                 
              }
              notLogInStudentObject["Is Terminated"] = null; //Assign no un answered candidates can be terminated
              for (let c = 0; c < this.columns.length; c++) {
                notLogInStudentObject[
                  `${this.columns[c]} (${this.categoryCount[this.columns[c]]})`
                ] = "Not started";
              }
              console.log("finalobject2", notLogInStudentObject);
              this.finaledArray.push(notLogInStudentObject);
              console.log("finaled final array", this.finaledArray);
            }
            if (this.studentdata.length == 0) {
              this.displayedColumns = Object.keys(this.finaledArray[0]);
              this.displayedColumns.push("Actions");
            }
            this.dataLength = this.finaledArray.length; //for pagination
            this.dataSource = new MatTableDataSource(this.finaledArray);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            console.log("datsource", this.dataSource);
            this.isLoading = false;
          } else {
            this.dataLength = this.finaledArray.length; //for pagination
            this.dataSource = new MatTableDataSource(this.finaledArray);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            console.log("datsource", this.dataSource);
            this.isLoading = false;
          }
        },
        err => {
          {
            console.error(err);
          }
        }
      );
  }

  async checkStatusOfUser(data) {
    console.log("in checking user status", data);

    const notLoggedInCandidateArray = this.finaledArray.filter(
      m => m["Is LoggedOut"] === "NA" && m["Username"] === data
    );

    console.log("not logged in candidate ", notLoggedInCandidateArray);

    const loggedOutCandidateArray = this.finaledArray.filter(
      m => m["Is LoggedOut"] === "Yes" && m["Username"] === data
    );

    console.log("logged out candidate ", loggedOutCandidateArray);

    if (notLoggedInCandidateArray.length > 0) {
      return "Not Logged";
    }

    if (loggedOutCandidateArray.length > 0) {
      return "Logged Out";
    }
  }
}
